import { getCSRFToken } from "~/lib/tokenStore";

const SIGN_IN_PATH = "/users/sign_in";

const signOutAndRedirect = ({ stopRefresh } = {}) => {
  if (stopRefresh) {
    stopRefresh();
  }

  return fetch("/users/sign_out", {
    method: "DELETE",
    headers: { "X-CSRF-Token": getCSRFToken() },
  })
    .catch(() => {})
    .finally(() => {
      window.location.href = SIGN_IN_PATH;
    });
};

export { SIGN_IN_PATH, signOutAndRedirect };
